/**
 * see: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
 *
 * Require lowercase Basic Latin letters - (?=.*[a-z])
 * Require uppercase Basic Latin letters - (?=.*[A-Z])
 * Require numbers - (?=.*\d)
 * Length must be at least 8 characters but fewer than 99 characters - {8,98}
 *
 * Special characters contained in this set are available:
 * ^ $ * . [ ] { } ( ) ? " ! @ # % & / \ , > < ' : ; | _ ~ ` = + -
 */
const REQUIRE_SMALLCASE_REGEXP = /^(?=.*[a-z]).*$/
const REQUIRE_UPPERCASE_REGEXP = /^(?=.*[A-Z]).*$/
const REQUIRE_NUMBER_REGEXP = /^(?=.*\d).*$/
const AVALIABLE_CHARS_REGEXP =
  /^[a-zA-Z\d^$*.[\]{}()?"!@#%&\/\\,><':;|_~`=+-]*$/

export const validatePassword = (
  password: string,
): { error: string } | undefined => {
  if (password.length < 8 || password.length > 98)
    return { error: 'パスワードは8文字以上98文字以内で設定してください。' }
  if (!REQUIRE_SMALLCASE_REGEXP.test(password))
    return {
      error: 'パスワードにはアルファベット小文字を1文字以上含めてください。',
    }
  if (!REQUIRE_UPPERCASE_REGEXP.test(password))
    return {
      error: 'パスワードにはアルファベット大文字を1文字以上含めてください。',
    }
  if (!REQUIRE_NUMBER_REGEXP.test(password))
    return { error: 'パスワードには数字を1文字以上含めてください。' }
  if (!AVALIABLE_CHARS_REGEXP.test(password))
    return { error: 'パスワードに利用できない文字が含まれています。' }
  return
}
export const AVALIABLE_SPECIAL_CHARS =
  '^ $ * . [ ] { } ( ) ? " ! @ # % & /  , > < \' : ; | _ ~ ` = + -'
